export default __webpack_public_path__ + "static/media/pickle_finance_logo.e2c8d7c7.webp";